// MyPayroll.js
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { updateNavbarHeading } from "../../../../constants/layout/store/filterSlice";
import { Table } from "react-bootstrap";
import { API_URL } from "../../../../constants/index";
import { GetServiceCaller } from "../../../../services/serviceCaller";
import AccordionSection from "./AccordionComponent";
import Select from "react-select";
import * as Yup from "yup";
import moment from "moment";
import { FaSpinner } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

const MyPayroll = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    dispatch(updateNavbarHeading("My Payroll"));
  }, []);

  const [datapayroll, setDataPayroll] = useState([]);
  const [listMonth, setListMonth] = useState([]);
  const [selectedMonth, setSelectedMonth] = useState(null);
  const [employeeData, setEmployeeData] = useState([]);
  const [attendanceData, setAttendanceData] = useState([]);
  const [dataEarning, setDataEarning] = useState([]);
  const [dataDeduction, setDataDeduction] = useState([]);
  const [grossPayable, setGrossPayable] = useState([]);
  const [totalDeductionData, setTotalDeductionData] = useState([]);
  const [netPayable, setNetPayable] = useState([]);
  const [loading, setLoading] = useState(true);
  const [pageLoading, setPageLoading] = useState(true);
  const [error, setError] = useState("");

  const [apiStatus,setApiStatus] = useState("")
  
  useEffect(() => {
    if (listMonth.length > 0) {
      setSelectedMonth(listMonth[0]);
    }
  }, [listMonth]);
  useEffect(() => {
    setTimeout(() => {
      fetchMyIndexPayroll();
      setLoading(false);
    }, 2000);
  }, []);

  const fetchMyPayroll = async (month) => {
    setApiStatus(undefined)
    try {
      const response = await GetServiceCaller(
        `${API_URL}my/payroll?P_MonthID=${month || 0}`
      );
      if (response.status === 200) {
        setApiStatus(response?.status)
        const payrolldata = response?.data?.payrolldata;
        setDataPayroll(payrolldata);
        // const MonthList = Object.entries(response?.data?.months).map(
        //   ([key, value]) => ({
        //     value: key,
        //     label: value,
        //   })
        // );
        // setListMonth(MonthList.reverse());
        const data = response?.data?.payrolldata?.employeeDetails;
        setEmployeeData(data);
        const dataAttendance = response?.data?.payrolldata?.attendanceDetails;
        setAttendanceData(dataAttendance);
        const earningsData = response?.data?.payrolldata?.earnings;
        setDataEarning(earningsData);
        const deductionData = response?.data?.payrolldata?.deductions;
        setDataDeduction(deductionData);
        const grossData = response?.data?.payrolldata?.grosspayable;
        setGrossPayable(grossData);
        const totalDeduction = response?.data?.payrolldata?.totaldeduction;
        setTotalDeductionData(totalDeduction);
        const netPayableData = response?.data?.payrolldata?.netPayable;
        setNetPayable(netPayableData);
        setPageLoading(false);
      } else {
        console.error(
          "Failed to fetch payroll data. Server responded with status:",
          response.status
        );
      }
    } catch (error) {
      console.error("Error fetching payroll data", error);
    }
  };
  const fetchMyIndexPayroll = async () => {
    try {
      const response = await GetServiceCaller(
        `${API_URL}my/payroll?P_MonthID=`
      );
      if (response.status === 200) {
        const payrolldata = response?.data?.payrolldata;
        setDataPayroll(payrolldata);
        const MonthList = Object.entries(response?.data?.months).map(
          ([key, value]) => ({
            value: key,
            label: value,
          })
        );
        setListMonth(MonthList.reverse());
        const data = response?.data?.payrolldata?.employeeDetails;
        setEmployeeData(data);
        const dataAttendance = response?.data?.payrolldata?.attendanceDetails;
        setAttendanceData(dataAttendance);
        const earningsData = response?.data?.payrolldata?.earnings;
        setDataEarning(earningsData);
        const deductionData = response?.data?.payrolldata?.deductions;
        setDataDeduction(deductionData);
        const grossData = response?.data?.payrolldata?.grosspayable;
        setGrossPayable(grossData);
        const totalDeduction = response?.data?.payrolldata?.totaldeduction;
        setTotalDeductionData(totalDeduction);
        const netPayableData = response?.data?.payrolldata?.netPayable;
        setNetPayable(netPayableData);
        setPageLoading(false);
      } else {
        console.error(
          "Failed to fetch payroll data. Server responded with status:",
          response.status
        );
      }
    } catch (error) {
      console.error("Error fetching payroll data", error);
    }
  };


  const validationSchema = Yup.object({
    selectedMonth: Yup.object().nullable().required("Please select a month"),
  });
  const handleGetDataClick = async () => {
    try {
      await validationSchema.validate({ selectedMonth });
      setError("");
      fetchMyPayroll(selectedMonth.value);
    } catch (validationError) {
      setError(validationError.message);
    }
  };

  // Render function for employee details
  const renderEmployeeDetails = (item) => (
    <div key={item.id}>
      <p style={{ fontSize: "14px", marginBottom:"0px" }}>
        <b>Designation</b>
      </p>
      <p style={{ fontSize: "14px" }}>{item.Designation}</p>
      <hr />
      <p style={{ fontSize: "14px", marginBottom:"0px" }}>
        <b>Joining Date</b>
      </p>
      <p style={{ fontSize: "14px" }}>
        {moment(item.JoiningDate).format("DD-MMM-YYYY")}
      </p>
      <hr />
      <p style={{ fontSize: "14px", marginBottom:"0px" }}>
        <b>Date Of Birth</b>
      </p>
      <p style={{ fontSize: "14px" }}>
        {moment(item.DateOfBirth).format("DD-MMM-YYYY")}
      </p>
      <hr />
      <p style={{ fontSize: "14px", marginBottom:"0px" }}>
        <b>PF No</b>
      </p>
      <p style={{ fontSize: "14px" }}>{item.PF}</p>
      <hr />
      <p style={{ fontSize: "14px", marginBottom:"0px" }}>
        <b>Emp Code</b>
      </p>
      <p style={{ fontSize: "14px" }}>{item.EmpCode}</p>
    </div>
  );

  // Render function for attendance details
  const renderAttendanceDetails = (item) => (
    <div key={item.id}>
      <p style={{ fontSize: "14px", marginBottom:"0px" }}>
        <b>Working Days</b>
      </p>
      <p style={{ fontSize: "14px" }}>{item.WorkingDays}</p>
      <hr />
      <p style={{ fontSize: "14px", marginBottom:"0px" }}>
        <b>Present Days</b>
      </p>
      <p style={{ fontSize: "14px" }}> {item.PresentDays}</p>
      <hr />
      <p style={{ fontSize: "14px", marginBottom:"0px" }}>
        <b>Absent Days</b>
      </p>
      <p style={{ fontSize: "14px" }}>{item.AbsentDays}</p>
      <hr />
      <p style={{ fontSize: "14px", marginBottom:"0px" }}>
        <b>Leave Taken</b>
      </p>
      <p style={{ fontSize: "14px" }}>{item.LeaveTaken}</p>
      <hr />
      <p style={{ fontSize: "14px", marginBottom:"0px" }}>
        <b>Leave Balance</b>
      </p>
      <p style={{ fontSize: "14px" }}>{item.LeaveBalance}</p>
    </div>
  );

  // Render function for earnings
  const renderEarnings = (item) => (
    <div key={item.id}>
      <p style={{ fontSize: "14px", marginBottom:"0px"  }}>
        <b>{item.Payroll}</b>
      </p>
      <p style={{ fontSize: "14px" }}>{item.Amount}</p>
      <hr />
    </div>
  );

  // Render function for deductions
  const renderDeductions = (item) => (
    <div key={item.id}>
      <p style={{ fontSize: "14px", marginBottom:"0px"  }}>
        <b>{item.Payroll}</b>
      </p>
      <p style={{ fontSize: "14px" }}>{item.Amount}</p>
      <hr />
    </div>
  );

  const handleChange = (option) => {
    setSelectedMonth(option);
    setError("");
  };
const handlePaySlipBtn = () => {
  navigate(`/user/pay-slip`, {
    state: { selectedMonth: selectedMonth.value }, // Fixed the syntax here
  });
};

  if (pageLoading) {
    return (
      <>
        <p class="position-absolute top-50 start-50 translate-middle text-center">
          <FaSpinner class="spinner" />
        </p>
      </>
    );
  } else {
    return (
      <>
        <div className="container-fluid" id="skill_section">
          <div className="container-fluid" id="skill-table-area">
            <div className="row">
              <div className="col-md-3">
                <div class="mb-3">
                  <label for="Code" class="form-label">
                    Month
                  </label>
                  <Select
                    options={listMonth}
                    value={selectedMonth}
                    onChange={(selectedOptions) =>
                      handleChange(selectedOptions)
                    }
                  />
                  {error && <div className="text-danger">{error}</div>}
                </div>
              </div>
              <div className="col-md-2">
                <div className="payroll-btn">
                  <button className="custom-btn" onClick={handleGetDataClick}>
                    Get Data
                  </button>
                </div>
              </div>
            </div>
        <div className="table-responsive">
  <Table bordered style={{ 
    width: "100%", 
    tableLayout: "auto",
    fontSize: "12px",
    margin: "0",
    padding: "0"
  }}>
    <thead id="thcolor" className="text-center" style={{ fontSize: "12px" }}>
      <tr>
        <th scope="col" style={{ width: "15%", padding: "4px" }}>Employee Details</th>
        <th scope="col" style={{ width: "15%", padding: "4px" }}>Attendance Details</th>
        <th scope="col" style={{ width: "12%", padding: "4px" }}>Earnings</th>
        <th scope="col" style={{ width: "10%", padding: "4px" }}>Others</th>
        <th scope="col" style={{ width: "10%", padding: "4px" }}>Gross Payable</th>
        <th scope="col" style={{ width: "12%", padding: "4px" }}>Deductions</th>
        <th scope="col" style={{ width: "10%", padding: "4px" }}>Total Deductions</th>
        <th scope="col" style={{ width: "10%", padding: "4px" }}>Net Payable</th>
        <th scope="col" style={{ width: "6%", padding: "4px" }}>Pay Slip</th>
      </tr>
    </thead>
    {apiStatus === undefined && datapayroll.length === 0 ? (
      <tbody>
        <tr>
          <td colSpan="9" className="text-center" style={{ padding: "4px" }}>
            <FaSpinner class="spinner" />
          </td>
        </tr>
      </tbody>
    ) : apiStatus === 200 && datapayroll.length === 0 ? (
      <tbody>
        <tr>
          <td colSpan="9" className="text-center" style={{ padding: "4px" }}>
            No Record Found
          </td>
        </tr>
      </tbody>
    ) : apiStatus === 200 && datapayroll.length != 0 ? (
      <tbody>
        <tr>
          <td style={{ padding: "4px", overflow: "hidden" }}>
            <AccordionSection
              title={
                (employeeData && employeeData[0]?.Employee) ||
                "Employee Details"
              }
              data={employeeData}
              renderContent={renderEmployeeDetails}
              accordionId="one"
            />
          </td>
          <td style={{ padding: "4px", overflow: "hidden" }}>
            <AccordionSection
              title="Attendance Details"
              data={attendanceData}
              renderContent={renderAttendanceDetails}
              accordionId="two"
            />
          </td>
          <td style={{ padding: "4px", overflow: "hidden" }}>
            <AccordionSection
              title="Earnings"
              data={dataEarning}
              renderContent={renderEarnings}
              accordionId="three"
            />
          </td>
          <td style={{ padding: "4px", overflow: "hidden" }}>
            <AccordionSection
              title="Others"
              data={[]}
              renderContent={() => <div>No content</div>}
              accordionId="four"
            />
          </td>
          <td className="text-end" style={{ padding: "4px", overflow: "hidden" }}>
            {grossPayable && grossPayable[0]?.Amount}
          </td>
          <td style={{ padding: "4px", overflow: "hidden" }}>
            <AccordionSection
              title="Deductions"
              data={dataDeduction}
              renderContent={renderDeductions}
              accordionId="five"
            />
          </td>
          <td className="text-end" style={{ padding: "4px", overflow: "hidden" }}>
            {totalDeductionData}
          </td>
          <td className="text-end" style={{ padding: "4px", overflow: "hidden" }}>
            {netPayable && netPayable[0]?.Amount}
          </td>
          <td className="text-center" style={{ padding: "4px", overflow: "hidden" }}>
            <button
              className="custom-btn"
              type="button"
              onClick={handlePaySlipBtn}
              style={{ 
                padding: "2px 4px",
                fontSize: "12px"
              }}
            >
              Pay Slip
            </button>
          </td>
        </tr>
      </tbody>
    ) : (
      <tbody>
        <tr>
          <td colSpan="9" className="text-center" style={{ padding: "4px" }}>
            No Record Found
          </td>
        </tr>
      </tbody>
    )}
  </Table>
</div>
          </div>
        </div>
      </>
    );
  }
};

export default MyPayroll;
